export interface IConfirmDashDonation {
    id: number,
    firstName: string,
    lastName: string,
    surgeryCompletedDateTime: string,
    centerId: number
}